import MetalFrioColor from 'assets/images/brands/metalfrio.png'
import MetalFrioWhite from 'assets/images/brands/metalfrio.png'

export const Wallet = {
    metalfrio: {
        name: "Metalfrio - Assistente virtual",
        shortname: "Metalfrio - Assistente virtual",
        logo_color: MetalFrioColor,
        logo_white: MetalFrioWhite,
        token:'73a6f135d1df994a5165045651bc328b',
        color: {
            primary: "#95267B",
            secondary: "#49b3ad"
        }
    }
}